// mixins/confirmReloadMixin.js
export default {
  data() {
    return {
      // Opcional: puedes mantener esto si quieres tener control programático
      enableReloadConfirmation: true
    }
  },

  mounted() {
    window.addEventListener('beforeunload', this.handleBeforeUnload)
    window.addEventListener('keydown', this.handleKeyDown)
  },

  beforeDestroy() {
    window.removeEventListener('beforeunload', this.handleBeforeUnload)
    window.removeEventListener('keydown', this.handleKeyDown)
  },

  methods: {
    handleBeforeUnload(event) {
      if (this.enableReloadConfirmation) {
        const confirmationMessage = '¿Estás seguro de que quieres salir? Los cambios no guardados pueden perderse.'
        event.preventDefault()
        event.returnValue = confirmationMessage
        return confirmationMessage
      }
    },

    handleKeyDown(event) {
      const isReloadKey = (
        event.keyCode === 116 || 
        (event.ctrlKey && event.keyCode === 82) ||
        (event.metaKey && event.keyCode === 82)
      )

      if (isReloadKey && this.enableReloadConfirmation) {
        const confirmed = confirm('¿Estás seguro de que deseas recargar la página?')
        if (!confirmed) {
          event.preventDefault()
          event.stopPropagation()
          return false
        } else {
          // Desactivá temporalmente beforeunload si el usuario confirmó
          this.disableReloadConfirm()
          // Dejás que el evento siga y se recargue sin doble confirmación
        }
      }
    },

    // Métodos opcionales para control programático
    enableReloadConfirm() {
      this.enableReloadConfirmation = true
    },

    disableReloadConfirm() {
      this.enableReloadConfirmation = false
    }
  }
}